import { Component } from '@angular/core';
import {RouterOutlet} from "@angular/router";
import {SharedModule} from "../../../shared/shared.module";
import {AgencySidebarComponent} from "../sidebar/agency-sidebar.component";
import {AgencyHeaderComponent} from "../agency-header/agency-header.component";
import {AgencyDashCardComponent} from "../agency-dash-card/agency-dash-card.component";
import {NgForOf} from "@angular/common";
import { AuthService } from '../../../services/auth.service';
import { userType } from '../../../shared/utils/enums';

@Component({
  selector: 'app-agency-dash',
  standalone: true,
  imports: [
    RouterOutlet,
    SharedModule,
    AgencySidebarComponent,
    AgencyHeaderComponent,
    AgencyDashCardComponent,
    NgForOf
  ],
  templateUrl: './agency-dash.component.html',
  styleUrl: './agency-dash.component.scss'
})
export class AgencyDashComponent {

  constructor(public auth: AuthService) { 
    this.auth.user?.kind == userType.agence ? this.menu = this.menuItems : this.menu = this.agencyUserMenuItems;

  }
  menu:any = [];
  menuItems:any = [
    {
      desc: 'Gestion des établissements',
      path: '/agency/establishment',
      btnText: 'ACCÉDER AUX ÉTABLISSEMENTS',
      icon: 'company'
    },
    {
      desc: 'Gestion des professionnels de santé',
      path: 'agency/candidates',
      btnText: 'ACCÉDER AUX PROFESSIONNELS',
      icon:'doctor'
    },
    {
      desc: 'Gestion de vos agences',
      path: 'agency/agencies',
      btnText: 'ACCÉDER AUX AGENCES',
      icon: 'agency'
    },
    {
      desc: 'Gestions de vos accès',
      path: 'agency/users',
      btnText: 'ACCÉDER AUX UTILISATEURS',
      icon:'padlock-tools'
    },
    {
      desc: 'Affectation directe',
      path: '/agency/direct-assign',
      btnText: 'ACCÉDER À L\'AFFECTATION DIRECTE',
      icon:'target'
    },
    {
      desc: "Relevés d'heures",
      path: '/agency/weekly-hours',
      btnText: 'ACCÉDER AUX RELEVÉS D\'HEURES',
      icon:'document'
    },
  ]

  agencyUserMenuItems:any = [
    {
      desc: 'Gestion des établissements',
      path: '/agency/establishment',
      btnText: 'ACCÉDER AUX ÉTABLISSEMENTS',
      icon: 'company'
    },
    {
      desc: 'Gestion des professionnels de santé',
      path: 'agency/candidates',
      btnText: 'ACCÉDER AUX PROFESSIONNELS',
      icon:'doctor'
    },
    {
      desc: 'Affectation directe',
      path: '/agency/direct-assign',
      btnText: 'ACCÉDER À L\'AFFECTATION DIRECTE',
      icon:'target'
    },
  ]
}
